import { render, staticRenderFns } from "./index_content.vue?vue&type=template&id=0447b24b"
import script from "./index_content.vue?vue&type=script&lang=js"
export * from "./index_content.vue?vue&type=script&lang=js"
import style0 from "./index_content.vue?vue&type=style&index=0&id=0447b24b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports